import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';

// Translations
import translate from '../../../../../lib/translation';

// Controller
import FilesModalController from './filesModal.controller';
import template from './filesModal.html';

const moduleName = 'staff.dashboardScreen.filesModal';
let module = angular.module(moduleName, [
  uiModal,
  translate
]);

module.controller('FilesModalController', FilesModalController);

module.factory('filesModal', ['$uibModal', '$q', ($uibModal, $q) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: FilesModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        documents: () => props.documents,
      }
    });
    return modal.result;
  };
}]);

export default module;

